import React, { useMemo } from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Table,
  Button,
  Space,
} from '@lockerpm/design';

import {
  EditOutlined,
  DeleteOutlined
} from "@ant-design/icons";

import itemsComponents from "../../../../../components/items";

import {
  convertDateTime,
} from '../../../../../utils/common'



const TableData = (props) => {
  const { TextCopy } = itemsComponents;
  const { t } = useTranslation();
  const isReadOnly = useSelector((state) => state.project.isReadOnly)

  const {
    loading = false,
    className = '',
    data = [],
    params = {},
    selectedRowKeys = [],
    selectionChange = () => {},
    onUpdate = () => {},
    onDelete = () => {}
  } = props;

  const columns = useMemo(() => {
    return [
      {
        title: t('common.no'),
        dataIndex: 'stt',
        key: 'stt',
        align: 'center',
        width: 80,
      },
      {
        title: t('environment.name'),
        dataIndex: 'name',
        key: 'name',
        width: 200,
        align: 'left',
        render: (_, record) => <TextCopy
          value={record.environment.name}
        />
      },
      {
        title: t('environment.external_url'),
        dataIndex: 'externalUrl',
        key: 'externalUrl',
        align: 'left',
        width: 300,
        render: (_, record) => <TextCopy
          value={record.environment.externalUrl}
        />
      },
      {
        title: t('common.created_time'),
        dataIndex: 'creationDate',
        key: 'creationDate',
        align: 'center',
        width: 200,
        render: (_, record) => <TextCopy
          value={convertDateTime(record.creationDate)}
          align={'center'}
        />
      },
      {
        title: t('common.updated_time'),
        dataIndex: 'updatedDate',
        key: 'updatedDate',
        align: 'center',
        width: 200,
        render: (_, record) => <TextCopy
          value={convertDateTime(record.updatedDate)}
          align={'center'}
        />
      },
      {
        title: t('common.actions'),
        dataIndex: 'actions',
        key: 'actions',
        align: 'center',
        fixed: 'right',
        width: 100,
        hide: isReadOnly,
        render: (_, record) => (
          <Space size={[8, 8]}>
            <Button
              icon={<EditOutlined />}
              type={'link'}
              onClick={() => onUpdate(record)}
            ></Button>
            <Button
              icon={<DeleteOutlined />}
              type={'link'}
              danger
              onClick={() => onDelete(record)}
            ></Button>
          </Space>
        ),
      },
    ].filter((c) => !c.hide)
  }, [isReadOnly])

  return (
    <Table
      className={className}
      columns={columns}
      dataSource={data.map((d, index) => ({ ...d, stt: index + 1 + (params.page - 1) * params.size }))}
      loading={loading}
      pagination={false}
      rowKey={(record) => record?.id}
      size="small"
      scroll={{ x: 1024 }}
      rowSelection={isReadOnly ? false : {
        columnWidth: 25,
        selectedRowKeys: selectedRowKeys,
        onChange: selectionChange,
      }}
    />
  );
}

export default TableData;
